import { mdiDeleteOutline, mdiPlusCircle } from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Tooltip } from "@mui/material";
import {
  OptActionToolbar,
  OptBackdrop,
  OptConfirmationDialog,
  OptGridRef,
  OptGridRequest,
  OptSearchField,
} from "@optsol/react";
import { useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Colors } from "../../../compartilhado/colors";
import { SearchRequest } from "../../../compartilhado/types/SearchRequest";
import { FiltroBusca } from "../../../componentes/filtro";
import { OptGridContainer } from "../../../componentes/OptGridContainer";
import { OptSideLayoutContentCustom } from "../../../componentes/optSideLayoutContentCustom/OptSideLayoutContentCustom";
import { CATEGORIA_FORM_INITIAL_STATE } from "../../../constantes/CategoriaFormInitialState";
import { TipoInput } from "../../../enums/tipoInput";
import { CategoriaFormModel } from "../../../modelos/categoria/categoriaFormModel";
import { CategoriaModel } from "../../../modelos/categoria/categoriaModel";
import { CategoriaSearchResponse } from "../../../modelos/dtos/CategoriaSearchResponse";
import { PaginatedSearchRequest } from "../../../modelos/search/PaginatedSearchRequest";
import { Rotas } from "../../../rotas";
import { useCategoriasService } from "../../../servicos/categorias.service";
import { GridCategoriasView } from "./GridCategoriaView";
import styles from "./styles/gridCategoria.module.scss";
import { useEventosService } from "../../../servicos/eventos.service";
import { PerfilUsuario } from "../../../enums/PerfilUsuario";

export const GridCategorias = () => {
  const [, setDrawerFormularioAberto] = useState(false);
  const [filtro, setFiltro] = useState<CategoriaFormModel>();
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const [confirmandoExclusao, setConfirmandoExclusao] =
    useState<boolean>(false);

  const [pessoa, setPessoa] = useState<CategoriaFormModel>(CATEGORIA_FORM_INITIAL_STATE);

  const { buscarGridCategoriasPaginated, removerCategoria, editarCategoria } =
  useCategoriasService();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const { verificarAutorizacao } = useEventosService();

  const opcoesFiltro = [
    { texto: "Nome", valor: 'nome', tipoInput: TipoInput.Texto },
    { texto: "Descrição", valor: 'descricao', tipoInput: TipoInput.Texto}
  ];

  function pesquisaComFiltro(filtro: CategoriaFormModel) {
    setFiltro(filtro);
  }

  const carregar = async (
    query: OptGridRequest,
    itemSearchRequest: PaginatedSearchRequest = {
      filtro: filtro,
    }
  ) => {
    const request: SearchRequest<PaginatedSearchRequest> = {
      page: query.page,
      pageSize: query.pageSize,
      filtro: itemSearchRequest.filtro,
    };
    return buscarGridCategoriasPaginated(request);
  };

  function onRowClick(rowData?: CategoriaModel) {
    if (rowData) {
    }
  }

  const gridRef = useRef<OptGridRef>(null);
  function recarregar() {
    gridRef.current?.refresh();
  }

  async function onClickDeleteCategoriaHandler() {
    setConfirmandoExclusao(false);
    setDeleteLoading(true);
    try {
      await removerCategoria(pessoa.id!);
      setDeleteLoading(false);
      enqueueSnackbar(`Registro excluído com sucesso!`, { variant: "success" });
      setDrawerFormularioAberto(false);
      setPessoa(CATEGORIA_FORM_INITIAL_STATE);
      recarregar();
    } catch {
      setDeleteLoading(false);
    }
  }

  async function onClickDeleteCategoria(rowData: CategoriaSearchResponse) {
    setPessoa(rowData);
    setConfirmandoExclusao(true);
  }

  async function onClickEditCategoria(rowData: CategoriaSearchResponse) {
    if (rowData.id) {
      history.push(`/categorias/cadastro/${rowData.id}`);
    }
  }

  function cancelarExclusao() {
    setConfirmandoExclusao(false);
  }

  function cadastrarCategoria() {
    history.push("/categorias/cadastro");
  }


  useEffect(() => {
    if (gridRef.current) {
      recarregar();
    }
  }, [filtro]);

  useEffect(() => {
    (async () => {
      verificarAutorizacao([PerfilUsuario.Administrador, PerfilUsuario.Operacao, PerfilUsuario.Gerente, PerfilUsuario.Consultor]);
    })()
  }, []);

  return (
    <>
      <OptConfirmationDialog
        open={confirmandoExclusao}
        title="Excluir Categorias"
        icon={{ path: mdiDeleteOutline, color: Colors.red }}
        onCancel={cancelarExclusao}
        onClose={cancelarExclusao}
        onConfirm={onClickDeleteCategoriaHandler}
      >
        Deseja confirmar a exclusão da categoria ? <br /> Essa operação não poderá ser desfeita.
      </OptConfirmationDialog>

      <OptBackdrop open={deleteLoading} />
      <OptSideLayoutContentCustom>
        <OptActionToolbar
          goBackRoute={Rotas.Home}
          title="Categorias"
          background={Colors.white}
          color={Colors.gray1}
          clearMargin
        ></OptActionToolbar>
        <OptGridContainer>
        <FiltroBusca opcoes={opcoesFiltro} pesquisa={pesquisaComFiltro} />
          <div className={styles.ButtonSection}>
            <Tooltip title={"Cadastrar categoria"}>
              <Button
                variant="contained"
                color="info"
                style={{ marginRight: "5px", marginBottom: "11px" }}
                placeholder="Cadastrar categoria"
                size="large"
                onClick={cadastrarCategoria}
              >
               Cadastrar Categoria <Icon path={mdiPlusCircle} size={1} color={Colors.primary} />
              </Button>
            </Tooltip>
          </div>
        </OptGridContainer>
        <GridCategoriasView
          carregar={carregar}
          onRowClick={onRowClick}
          onClickDelete={onClickDeleteCategoria}
          onClickEdit={onClickEditCategoria}
          gridRef={gridRef}
        />
      </OptSideLayoutContentCustom>
    </>
  );
};
